export var UNITS = {
    // admixUnits
    ml: "ml",
    usfloz: "fl oz",
    // admixRatioUnit
    "ml/m^3": "ml/m\u00B3",
    "usfloz/yd^3": "fl oz/yd\u00B3",
    // loadSizeUnit
    "m^3": "m\u00B3",
    "yd^3": "yd\u00B3",
    // slumpUnits
    in: "in",
    mm: "mm",
    cm: "cm",
    // speedUnits
    kph: "kph",
    mph: "mph",
    // temperatureUnit
    degC: "\u00b0C",
    degF: "\u00b0F",
    // waterUnit
    l: "l",
    gal: "gal",
    // waterRatioUnit
    "l/m^3": "l/m\u00B3",
    "gal/yd^3": "gal/yd\u00B3",
};
//# sourceMappingURL=units.js.map